import React, { useEffect, useState } from "react";
import moment from "moment";
import { ExpertButton } from "../../Pages/ExpertProfilePage/StyledComponents";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import { bindActionCreators } from "redux";
import { useDispatch, useSelector } from "react-redux";
import { Actions } from "../../Action";
import { toast } from "react-toastify";
import { updateSeekerProfileData } from "../../API/api";
import EditIcon from '@mui/icons-material/Edit';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import UpdateIcon from '@mui/icons-material/Update';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import Button from "../../NewComponent/Button/Button";
import Button2 from "../../NewComponent/Button2/Button2";


const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});


export default function OutOfOffice({ firstName, lastName, outofOfficeData, deleteByIndex }) {
  const userState = useSelector((state) => state.user);
  const [vacationStart, setVacationStart] = useState(null);
  const [vacationEnd, setVacationEnd] = useState(null);
  const [isUpdate, setIsUpdate] = useState(false);
  const [dateError, setDateError] = useState(false);
  const [propData, setPrpData] = useState(outofOfficeData);
  const dispatch = useDispatch();
  const { storeUserData } = bindActionCreators(Actions, dispatch);
  const [index, setIndex] = useState(null);
  const [open, setOpen] = React.useState(false);
  const onChangeVacationStart = (e) => {
    if(e.target.value !== '' || undefined)
    {
    setVacationStart(e.target.value);
    }
    else 
    {
      setVacationStart('')
    }
  }
  const onChangeVacationEnd = (e) => {
    if(e.target.value !== '' || undefined)
    {
    setVacationEnd(new Date(e.target.value).toISOString().slice(0, 10));
    }
    else 
    {
      setVacationEnd('')
    }
  }
  const toggleButtonToast = () => {
    return (
      <>
        <span style={{ fontSize: "12px" }}>
          Profile has been updated.
        </span>
      </>
    );
  };
  const dateRangeOverlap = () => {
    return (
      <span style={{ fontFamily: "inherit", fontSize: "12px" }}>
          Selected Date range overlaps with existing Date
      </span>
    )
  }

  const dateCompare = () => {
    return (
      <span style={{ fontFamily: "inherit", fontSize: "12px" }}>
          Start Date cannot be longer than end date
      </span>
    )
  }
  // const dateObject = {
  //   startTime: moment(vacationStart).unix() * 1000, endTime: moment(vacationEnd).unix() * 1000
  // }
    const dateObject = {
    startTime: new Date(vacationStart).setHours(0,0,0,0), endTime: new Date(vacationEnd).setHours(0,0,0,0)
  }
  const handleSaveButtonData = () => {
    const payloadData = {
      confirmPassword: "",
      currentPassword: "",
      firstName: firstName === '' ? userState.firstName : firstName,
      lastName: lastName === '' ? userState.lastName : lastName,
      newPassword: "",
      outOfOffice: propData,
    }
    updateSeekerProfileData(payloadData).then((res) => {
      if (res===undefined) return;
      if (res.data.data !== '' && res.data.success) {
        userState.outOfOffice = propData;
        storeUserData(userState);
        toast.success(toggleButtonToast(), {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    })
  }

  function isVacationExist(start, end) {
    let isExist = false;
    userState.outOfOffice && userState.outOfOffice.length > 0 && userState.outOfOffice.filter(obj => {
      if ((obj.startTime <= start && obj.endTime >= start) || (obj.startTime <= end && obj.endTime >= end)) {
        isExist = true;
        setDateError(true);
      }
      if ((start <= obj.startTime && end >= obj.startTime) || (start <= obj.endTime && end >= obj.endTime)) {
        isExist = true;
        setDateError(true);
      }
      return obj;
    })
    return isExist;
  }

  const updateState = (ind) => {
    if(dateObject.startTime >= dateObject.endTime)
    {
      setOpen(true)
      return(
        toast.error(dateCompare(), {
          position: toast.POSITION.TOP_RIGHT,
          hideProgressBar: true
        })
      )
    }
    if (dateObject.startTime < dateObject.endTime) {
      let newArray = propData.map((obj, i) => {
        if (i === ind) {
          return { ...obj, startTime: dateObject.startTime, endTime: dateObject.endTime }
        }
        return obj;
      })
      setPrpData(newArray);
      const getStoredWeeklyDigest = sessionStorage.getItem('weeklyDigest');
      const weeklyDigest = JSON.parse(getStoredWeeklyDigest);
      const payloadData = {
        confirmPassword: "",
        currentPassword: "",
        firstName: firstName === '' ? userState.firstName : firstName,
        lastName: lastName === '' ? userState.lastName : lastName,
        newPassword: "",
        outOfOffice: newArray,
        weeklyDigest:weeklyDigest
      }
      updateSeekerProfileData(payloadData).then((res) => {
        if (res===undefined) return;
        if (res.data.data !== '' && res.data.success) {
          userState.outOfOffice = newArray;
          let newObj = {...userState}
          storeUserData(newObj);
          sessionStorage.setItem('outOfOffice',JSON.stringify(newArray))
          toast.success(toggleButtonToast(), {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      })
    }
  }

  const onClickVacationDates = (start, end) => {
    if (isUpdate === false) {
      let flag = isVacationExist(new Date(start).setHours(0,0,0,0), new Date(end).setHours(0,0,0,0));
      // const asf = { startTime: new Date(start).getTime(), endTime: new Date(end).getTime() }
      const asf = { startTime: new Date(start).setHours(0,0,0,0),endTime: new Date(end).setHours(0,0,0,0)};
      if (flag) {
        toast.error(dateRangeOverlap(), {
          position: toast.POSITION.TOP_RIGHT,
          hideProgressBar: true
        })
        setVacationStart('');
        setVacationEnd('');
        return;
      }
      if(!flag && asf.startTime > asf.endTime)
      {
        setOpen(true);
        return (
          toast.error(dateCompare(), {
            position: toast.POSITION.TOP_RIGHT,
            hideProgressBar: true
          })
        )
      }
      if ((!flag && asf.startTime < asf.endTime) || (asf.startTime === asf.endTime)) {
        const newArray = userState.outOfOffice;
        const weeklyDigestValue = sessionStorage.getItem('weeklyDigest');
        const weeklyDigest = JSON.parse(weeklyDigestValue) || 0
        newArray.push(asf);
        setPrpData(newArray);
        const payloadData = {
          confirmPassword: "",
          currentPassword: "",
          firstName: firstName === '' ? userState.firstName : firstName,
          lastName: lastName === '' ? userState.lastName : lastName,
          newPassword: "",
          outOfOffice: propData,
          weeklyDigest:weeklyDigest
          // outOfOffice:newArray
        }
        updateSeekerProfileData(payloadData).then((res) => {
          if (res===undefined) return;
          if (res.data.data !== '' && res.data.success) {
            userState.outOfOffice = propData;
            let newObj = {...userState}
            storeUserData(newObj);
            sessionStorage.setItem('outOfOffice',JSON.stringify(propData));
            toast.success(toggleButtonToast(), {
              position: toast.POSITION.TOP_RIGHT,
            });
          }
        })
        setVacationStart('');
        setVacationEnd('');
      }
    }
    if (isUpdate === true) {
      updateState(index);
      // setIndex(updateState);
      setIsUpdate(false);
      setVacationStart('');
      setVacationEnd('');
    }
  }
  const OutOfOfficeRender = ({ da, i }) => {
    const [edit, setIsEdit] = useState(false);
    const onClickEdit = (val) => {
      setIsUpdate(true);
      setIsEdit(!edit);
      setVacationStart(moment.unix((val.startTime) / 1000).format("YYYY-MM-DD"));
      setVacationEnd(moment.unix((val.endTime) / 1000).format("YYYY-MM-DD"));
      setIndex(i);
    }

    const onClickRemoveData = (index) => {
      const newArray = propData.filter((_, i) => i !== index);
      setPrpData(newArray);
      if (newArray.length === 0) {
        setVacationStart(null);
        setVacationEnd(null);
        if (isUpdate === true) {
          setIsUpdate(false);
        }
      }
      setVacationStart('');
      setVacationEnd('');
      setIsUpdate(false);
      const weeklyDigestValue = sessionStorage.getItem('weeklyDigest');
      const weeklyDigest = JSON.parse(weeklyDigestValue)
      const payloadData = {
        confirmPassword: "",
        currentPassword: "",
        firstName: firstName === '' ? userState.firstName : firstName,
        lastName: lastName === '' ? userState.lastName : lastName,
        newPassword: "",
        outOfOffice: newArray,
        weeklyDigest:weeklyDigest
      }
      updateSeekerProfileData(payloadData).then((res) => {
        if (res===undefined) return;
        if (res.data.data !== '' && res.data.success) {
          // userState.outOfOffice = newArray;
          userState.outOfOffice = newArray;
          let newObj = {...userState}
          storeUserData(newObj);
          sessionStorage.setItem('outOfOffice',JSON.stringify(newArray));
          toast.success(toggleButtonToast(), {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      })
    }
    return (
      <>
        <div style={{ display: "flex", justifyContent: "space-between", paddingTop: "12px", fontSize: "14px" }}>
          <div style={{ display: "flex" }}>{moment.unix((da.startTime) / 1000).format('L')}
            <p style={{ paddingLeft: "3px", paddingRight: "3px" }}>-</p>
            <div>{(moment.unix((da.endTime) / 1000)).format('L')}</div>
          </div>
          <div style={{display:'flex',gap:'7px'}}>
            {/* <button className="expertAdd" style={{ marginRight: "5px", fontSize: "14px" }} onClick={() => onClickEdit(da)} disabled={edit ? true : false}>Edit</button> */}{/* Not needed */}
            {/* {edit ? <span style={{opacity:'0.5',pointerEvents:'none'}}><Button text={'Edit'} type='primary' onClickFunc={()=>onClickEdit(da)} /></span> :<Button text={'Edit'} type='primary' onClickFunc={()=>onClickEdit(da)} /> } */}
            {/* <ExpertButton onClick={() => onClickEdit(da)} disabled={edit ? true : false} sx={{ marginRight: "5px" }}><EditIcon fontSize="small" /></ExpertButton> */}
            {edit ? <span style={{opacity:'0.5',pointerEvents:'none'}}><Button2 type={'dark'} children={<EditIcon fontSize="small" />} onClickFunc={()=>onClickEdit(da)} /></span> : <Button2 type={'primary'} children={<EditIcon fontSize="small" />} onClickFunc={()=>onClickEdit(da)} />}
            {/* <ExpertButton onClick={() => onClickRemoveData(i)} disabled={edit ? true : false}><RemoveCircleIcon sx={{ padding: "3px" }} fontSize="small" /></ExpertButton> */}
            {edit ? <span style={{opacity:'0.5',pointerEvents:'none'}}><Button2 onClickFunc={()=>onClickRemoveData(i)} children={<RemoveCircleIcon fontSize="small" />} type={'dark'} /></span> :<Button2 onClickFunc={()=>onClickRemoveData(i)} children={<RemoveCircleIcon fontSize="small" />} type={'dark'} /> }
          </div>
        </div>
      </>
    )
  }

  return (
    <>
      <div>
        <div>
          <div style={{ display: "flex",flexWrap:"wrap",alignItems:'center' }}>
            <input type="date" max="9999-12-31" contentEditable value={vacationStart} className="dateInput" onChange={(e) => onChangeVacationStart(e)} min={new Date().toISOString().split('T')[0]} />
            <span style={{ paddingLeft: "10px", paddingRight: "10px", fontSize: "15px", fontFamily: "Poppins,Lato,sans-serif" }}>To</span>
            <input type="date" max="9999-12-31" value={vacationEnd} className="dateInput" min={vacationStart} onChange={(e) => onChangeVacationEnd(e)} />
            <div style={{ marginLeft: "auto" }}>
              {/* <button className="expertAdd" style={{ fontSize: "14px" }} disabled={(vacationStart === '' || vacationEnd === '') || (vacationStart > vacationEnd) ? true : false} onClick={() => onClickVacationDates(vacationStart, vacationEnd)}>{isUpdate ? "Update" : "Add"}</button> */}
              {/* <ExpertButton disabled={(!vacationStart || !vacationEnd) ? true : false} onClick={() => onClickVacationDates(vacationStart, vacationEnd)} >{isUpdate ? <UpdateIcon fontSize="medium" sx={{ padding: "3px" }} /> : <AddCircleIcon fontSize="medium" sx={{ padding: "3px" }} />}{isUpdate ? "Update" : "Add"}</ExpertButton> */}
              {(!vacationStart || !vacationEnd) ? <span style={{opacity:0.5,pointerEvents:'none'}}>
                <Button type={'primary'} text={isUpdate ? "Update" : "Add"} onClickFunc={()=>onClickVacationDates(vacationStart,vacationEnd)} />
              </span> : <Button text={isUpdate ? "Update" : "Add"} onClickFunc={()=>onClickVacationDates(vacationStart,vacationEnd)} type="primary" /> }
            </div>
          </div>
          {propData.length > 0 && propData.map((da, i) => {
            return (
              <>
                <OutOfOfficeRender da={da} key={i} i={i} />
              </>
            )
          })}
        </div>
      </div>
    </>
  )
}